import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft, FiCompass, FiHome } from "react-icons/fi";
import Footer from "../Footer/Footer";
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import "./NotFound.css";

function NotFound() {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, setIsShow] = useState(false);

  const handleScroll = (event) => {
    if (event.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }

    if (event.target.scrollTop === 0 && isScrolled) {
      setIsScrolled(false);
    }
  };

  const handleClick = () => {
    setIsShow(!isShow);
  };

  return (
    <div className="home_main notfound_page" onScroll={handleScroll}>
      <Navbar isScrolled={isScrolled} handleClick={handleClick} />
      <NavbarMenu isShow={isShow} handleClick={handleClick} />

      <section className="notfound_hero">
        <div className="notfound_glow notfound_glow_left" />
        <div className="notfound_glow notfound_glow_right" />

        <div className="notfound_shell" data-aos="fade-up">
          <div className="notfound_card">
            <div className="notfound_badge">
              <FiCompass />
              <span>404 Error</span>
            </div>

            <div className="notfound_digits">404</div>
            <h1>It seems this page has moved beyond our campus map.</h1>
            <p>
              We looked around, but this page is not on campus right now. Try
              heading back or return home and we will get you back on track.
            </p>

            <div className="notfound_actions">
              <button
                type="button"
                className="notfound_button notfound_button_primary"
                onClick={() => navigate("/")}
              >
                <FiHome />
                Go to Home
              </button>
              <button
                type="button"
                className="notfound_button notfound_button_secondary"
                onClick={() => navigate(-1)}
              >
                <FiArrowLeft />
                Go Back
              </button>
            </div>
            <div className="notfound_note">
              A small detour, nothing more.
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default NotFound;
